module.exports = __webpack_public_path__ + "static/media/rapidNaming-intro2.74f8dff1.mp3";